export default {
	data: ()=>({
		mounted: false,
	}),
	mounted(){
		this.mounted = true;
	},
}